import Vue from 'vue';

import ajax from './ajax';

export default {
  state: {
    data: {
      general: { siteInfo: {}, defaults: {} },
      deviceInfo: {
        model: 0,
        serial: '',
        loaded: false,
      },
      pinEnabled: true,
      loads: [],
      allCts: [],
      inputs: [],
      alarms: [],
      ethernet: {},
      communications: [],
      pulse: [],
      report: {
        general: {},
        meter: {},
        generalNotes: {},
        measuredValues: [],
        meterValues: [],
      },
    },
    debugMode: false,
    updatingFirmware: false,
    selectedCt: {},
    usedCts: [],
    unusedCts: [],
    selectedInput: {},
    timeUpdated: false,
    basetime: 0,
    now: new Date(),
    timeInterval: null,
    style: 'setra',
    mappingSaved: false,
    voltageDirty: false,
    loadDirty: false,
    ctDirty: false,
    selectedPulse: {},
    pulseDirty: false,
    pulseSaved: false,
    pulseValid: true,
    communicationsDirty: false,
    communicationsSaved: false,
    communicationsValid: true,
    generalDirty: false,
    generalSaved: false,
    generalValid: true,
    alarmsDirty: false,
    overlappingAlarmsDirty: false,
    alarmsSaved: false,
    alarmsValid: true,
    reportDirty: false,
    reportSaved: false,
    reportValid: true,
    eventLog: [],
    alarmLog: [],
    alarmStates: [],
    alarmLed: false,
    alarmRelay: false,
    journalEntries: [],
    vdis: [],
    timezones: [],
    timezone: '',
    timezoneIndex: -1,
    alarmTypes: [
      {
        text: 'Over Power',
        value: 0,
        unit: 'kW',
        deadbandUnit: 'kW',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when instantaneous power is above {SetPoint} exceeding {Delay} for {Load}. {AlarmResult} {Warning}',
        descriptionWarning: 'The alarm will deactivate when instantaneous power is below {SetPointMinusDeadband} exceeding {Delay}.',
        overlapNote: 'Note:  If this alarm is set on the same load as an Under Power alarm type, the delay value and deadband value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Under Power',
        value: 1,
        unit: 'kW',
        deadbandUnit: 'kW',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when instantaneous power is below {SetPoint} exceeding {Delay} for {Load}. {AlarmResult} {Warning}',
        descriptionWarning: 'The alarm will deactivate when instantaneous power is above {SetPointPlusDeadband} exceeding {Delay}.',
        overlapNote: 'Note:  If this alarm is set on the same load as an Over Power alarm type, the delay value and deadband value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Energy Usage (Vin)',
        value: 2,
        unit: 'kWh',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: false,
        vinApplicable: true,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: false,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when energy (kWh+) usage for {Vin} exceeds {SetPoint}. {AlarmResult}',
      },
      {
        text: 'Energy Usage (Load)',
        value: 3,
        unit: 'kWh',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: false,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when energy (kWh+) usage for {Load} exceeds {SetPoint}. {AlarmResult}',
      },
      {
        text: 'Polarity CT',
        value: 4,
        unit: 'A',
        deadbandUnit: '',
        setPointApplicable: false,
        delayApplicable: false,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: true,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate on negative power for {Ct}. {AlarmResult}',
      },
      {
        text: 'Under Current CT',
        value: 5,
        unit: 'A',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: true,
        defaultSetPoint: 1,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate on {SetPoint} or less flowing through {Ct} for {DelayTime}. {AlarmResult}',
        overlapNote: 'Note:  If this alarm is set on the same CT as an Over Current CT alarm type, the delay value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Over Current CT',
        value: 6,
        unit: 'A',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: false,
        ctApplicable: true,
        defaultSetPoint: 10,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate on more than {SetPoint} flowing through {Ct} for {DelayTime}. {AlarmResult}',
        overlapNote: 'Note:  If this alarm is set on the same CT as an Under Current CT alarm type, the delay value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Phase Loss',
        value: 7,
        unit: '%',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 10,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when the calculated current unbalance is greater than {SetPoint} for {DelayTime}.  Current unbalance is calculated as the maximum deviation divided by the average current of the load phases multiplied by 100%.  This alarm is intended to alert the user to a lost phase or significant phase current imbalance. {AlarmResult}',
      },
      {
        text: 'Under Voltage',
        value: 8,
        unit: '%',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: true,
        loadApplicable: false,
        ctApplicable: false,
        defaultSetPoint: 90,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when the voltage of {Line} goes below {SetPoint} of {LineExpectedVoltage} for {DelayTime}. {AlarmResult}',
        overlapNote: 'Note:  If this alarm is set on the same line as an Over Voltage alarm type, the delay value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Over Voltage',
        value: 9,
        unit: '%',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: true,
        loadApplicable: false,
        ctApplicable: false,
        defaultSetPoint: 110,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when the voltage of {Line} goes above {SetPoint} of {LineExpectedVoltage} for {DelayTime}. {AlarmResult}',
        overlapNote: 'Note:  If this alarm is set on the same line as an Under Voltage alarm type, the delay value will be common between the alarms.  The last of these two alarms listed in the Alarm Configuration table will take precedence.',
      },
      {
        text: 'Over Current (Load)',
        value: 10,
        unit: 'A',
        deadbandUnit: 'A',
        setPointApplicable: true,
        delayApplicable: true,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 10,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when the current exceeds {SetPoint} for {DelayTime} for {Load}. {AlarmResult} {Warning}',
        descriptionWarning: 'A warning will be logged when the current exceeds {SetPointMinusDeadband} for {DelayTime}.',
        overlapNote: 'Note: Alarm Set Point should not exceed the maximum rating of any CT configured for the load.',

      },
      {
        text: 'Peak Demand (Load)',
        value: 11,
        unit: 'kW',
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: false,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 1000,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when peak demand of {SetPoint} is exceeded for {Load}. {AlarmResult}',
      },
      {
        text: 'Low Power Factor',
        value: 12,
        unit: '',
        floatAsInteger: true, // Only allow 0-1 with 2 decimals to be stored as 0-100
        deadbandUnit: '',
        setPointApplicable: true,
        delayApplicable: false,
        vinApplicable: false,
        lineApplicable: false,
        loadApplicable: true,
        ctApplicable: false,
        defaultSetPoint: 0.5,
        defaultDeadband: 0,
        defaultDelay: 1,
        description: 'This alarm will activate when the Power Factor is below {SetPoint} for {Load}. {AlarmResult}',
      },
    ],
    ctTypes: [
      {
        text: 'None',
        value: 0,
        maxCurrent: null,
        maxVoltage: null,
        type: 'none',
      },
      {
        text: 'CTS-020 (20 Amp)',
        value: 1,
        maxCurrent: 20,
        maxVoltage: 333,
        type: 'clamp',
      },
      {
        text: 'CTS-050 (50 Amp)',
        value: 2,
        maxCurrent: 50,
        maxVoltage: 333,
        type: 'clamp',
      },
      {
        text: 'CTS-100 (100 Amp)',
        value: 3,
        maxCurrent: 100,
        maxVoltage: 333,
        type: 'clamp',
      },
      {
        text: 'CTS-200 (200 Amp)',
        value: 4,
        maxCurrent: 200,
        maxVoltage: 333,
        type: 'clamp',
      },
      {
        text: 'CTS-400 (400 Amp)',
        value: 5,
        maxCurrent: 400,
        maxVoltage: 333,
        type: 'clamp',
      },
      {
        text: 'CT-PF-12 (1500 Amp)',
        value: 6,
        maxCurrent: 1500,
        maxVoltage: 108,
        type: 'rogo',
      },
      {
        text: 'CT-PF-24 (3000 Amp)',
        value: 7,
        maxCurrent: 3000,
        maxVoltage: 108,
        type: 'rogo',
      },
      {
        text: 'CT-PF-36 (6000 Amp)',
        value: 8,
        maxCurrent: 6000,
        maxVoltage: 108,
        type: 'rogo',
      },
      {
        text: 'User defined',
        value: 9,
        maxCurrent: null,
        maxVoltage: null,
        type: 'custom',
      },
    ],
    serviceOptions: [
      { text: '4-Wire wye', value: 1 },
      { text: '3-Wire delta', value: 2 },
      { text: '3-Wire single phase (split-phase)', value: 4 },
      { text: '2-Wire single phase', value: 5 },
    ],
    communicationTypeOptions: [
      { text: 'None', value: 'none' },
      { text: 'BACnet/IP', value: 'bac_ip' },
      { text: 'BACnet MS/TP', value: 'bac_mstp' },
      { text: 'Modbus TCP', value: 'mb_tcp' },
      { text: 'Modbus RTU', value: 'mb_rtu' },
    ],
    parityOptions: [
      { text: 'None', value: 78 },
      { text: 'Even', value: 69 },
      { text: 'Odd', value: 79 },
    ],
    pulseTypeOptions: [
      { text: 'Electrical', value: 0 },
      { text: 'Water', value: 1 },
      { text: 'Gas', value: 2 },
      { text: 'Steam', value: 3 },
      { text: 'BTU / Energy', value: 4 },
      { text: 'Event Counter', value: 5 },
    ],
    pulseOutTypeOptions: [
      { text: 'Energy', value: 4 },
    ],
    pulseMeasureOptions: [
      // Electrical
      [
        { text: 'No units', value: 95 },
        { text: 'Milliamperes', value: 2 },
        { text: 'Amperes', value: 3 },
        { text: 'Volts', value: 5 },
        { text: 'Millivolts', value: 124 },
        { text: 'Kilovolts', value: 6 },
        { text: 'Megavolts', value: 7 },
        { text: 'Volt Amperes', value: 8 },
        { text: 'Kilovolt Amperes', value: 9 },
        { text: 'Megavolt Amperes', value: 10 },
        { text: 'Volt Amperes Reactive', value: 11 },
        { text: 'kilovolt Amperes Reactive', value: 12 },
        { text: 'Megavolt Amperes Reactive', value: 13 },
        { text: 'Degrees Phase', value: 14 },
        { text: 'Power Factor', value: 15 },
      ],
      // Water
      [
        { text: 'No units', value: 95 },
        { text: 'Cubic Feet', value: 79 },
        { text: 'Cubic Meters', value: 80 },
        { text: 'Imperial Gallons', value: 81 },
        { text: 'Milliliters', value: 197 },
        { text: 'Liters', value: 82 },
        { text: 'US Gallons', value: 83 },
      ],
      // Gas
      [
        { text: 'No units', value: 95 },
        { text: 'Cubic Feet Per Second', value: 142 },
        { text: 'Cubic Feet Per Minute', value: 84 },
        { text: 'Million Standard Cubic Feet Per Minute', value: 254 },
        { text: 'Cubic Feet Per Hour', value: 191 },
        { text: 'Cubic Feet Per Day', value: 248 },
        { text: 'Standard Cubic Feet Per Day', value: 47808 },
        { text: 'Million Standard Cubic Feet Per Day', value: 47809 },
        { text: 'Thousand Cubic Feet Per Day', value: 47810 },
        { text: 'Thousand Standard Cubic Feet Per Day', value: 47811 },
        { text: 'Pounds Mass Per Day', value: 47812 },
        { text: 'Cubic Meters Per Second', value: 85 },
        { text: 'Cubic Meters Per Minute', value: 165 },
        { text: 'Cubic Meters Per Hour', value: 135 },
        { text: 'Cubic Meters Per Day', value: 249 },
        { text: 'Imperial Gallons Per Minute', value: 86 },
        { text: 'Milliliters Per Second', value: 198 },
        { text: 'Liters Per Second', value: 87 },
        { text: 'Liters Per Minute', value: 88 },
        { text: 'Liters Per Hour', value: 136 },
        { text: 'US Gallons Per Minute', value: 89 },
        { text: 'US Gallons Per Hour', value: 192 },
      ],
      // Steam
      [
        { text: 'No units', value: 95 },
        { text: 'Cubic Feet Per Second', value: 142 },
        { text: 'Cubic Feet Per Minute', value: 84 },
        { text: 'Million Standard Cubic Feet Per Minute', value: 254 },
        { text: 'Cubic Feet Per Hour', value: 191 },
        { text: 'Cubic Feet Per Day', value: 248 },
        { text: 'Standard Cubic Feet Per Day', value: 47808 },
        { text: 'Million Standard Cubic Feet Per Day', value: 47809 },
        { text: 'Thousand Cubic Feet Per Day', value: 47810 },
        { text: 'Thousand Standard Cubic Feet Per Day', value: 47811 },
        { text: 'Pounds Mass Per Day', value: 47812 },
        { text: 'Cubic Meters Per Second', value: 85 },
        { text: 'Cubic Meters Per Minute', value: 165 },
        { text: 'Cubic Meters Per Hour', value: 135 },
        { text: 'Cubic Meters Per Day', value: 249 },
        { text: 'Imperial Gallons Per Minute', value: 86 },
        { text: 'Milliliters Per Second', value: 198 },
        { text: 'Liters Per Second', value: 87 },
        { text: 'Liters Per Minute', value: 88 },
        { text: 'Liters Per Hour', value: 136 },
        { text: 'US Gallons Per Minute', value: 89 },
        { text: 'US Gallons Per Hour', value: 192 },
      ],
      // BTU / Energy
      [
        { text: 'No units', value: 95 },
        { text: 'Ampere Seconds', value: 238 },
        { text: 'Volt Ampere Hours', value: 239 },
        { text: 'Kilovolt Ampere Hours', value: 240 },
        { text: 'Megavolt Ampere Hours', value: 241 },
        { text: 'Volt Ampere Hours Reactive', value: 242 },
        { text: 'Kilovolt Ampere Hours Reactive', value: 243 },
        { text: 'Megavolt Ampere Hours Reactive', value: 244 },
        { text: 'Volt Square Hours', value: 245 },
        { text: 'Ampere Square Hours', value: 246 },
        { text: 'Joules', value: 16 },
        { text: 'Kilojoules', value: 17 },
        { text: 'Kilojoules Per Kilogram', value: 125 },
        { text: 'Megajoules', value: 126 },
        { text: 'Watt Hours', value: 18 },
        { text: 'Kilowatt Hours', value: 19 },
        { text: 'Megawatt Hours', value: 146 },
        { text: 'Watt Hours Reactive', value: 203 },
        { text: 'Kilowatt Hours Reactive', value: 204 },
        { text: 'Megawatt Hours Reactive', value: 205 },
        { text: 'Btus', value: 20 },
        { text: 'Kilo Btus', value: 147 },
        { text: 'Mega Btus', value: 148 },
        { text: 'Therms', value: 21 },
        { text: 'Ton Hours', value: 22 },
      ],
      // Event counter
      [
        { text: 'No units', value: 95 },
      ],
    ],
    pulseOutMeasureOptions: [
      // Electrical
      [], [], [], [],
      // Energy
      [
        { text: 'Kilowatt Hours (kWh+)', value: 19 },
        { text: 'Kilovolt Ampere Hours Reactive (kvarh_Q4 plus kvarh_Q1)', value: 243 },
        { text: 'Kilovolt Ampere Hours (kVAh+)', value: 240 },
      ],
    ],
  },
  addEventLog(message) {
    const timestamp = new Date();
    const logLine = { time: timestamp, text: message };
    this.state.eventLog.push(logLine);
    ajax.post('config/log', logLine)
      .then(() => {
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateVdis(item) {
    this.state.vdis = [];
    if (this.state.data.communications.bacnet !== undefined && this.state.data.communications.bacnet.baseInstance !== undefined) {
      this.state.vdis.push(this.state.data.communications.bacnet.baseInstance);
    }
    Object.values(this.state.data.loads).forEach((load) => {
      if (load !== item && load.vdi !== null && load.vdi !== undefined && load.vdi !== '' && load.vdi !== 4194303) {
        this.state.vdis.push(load.vdi);
      }
    });
    Object.values(this.state.data.allCts).forEach((ct) => {
      if (ct !== item && ct.vdi !== null && ct.vdi !== undefined && ct.vdi !== '' && ct.vdi !== 4194303) {
        this.state.vdis.push(ct.vdi);
      }
    });
  },
  updateCts(item) {
    this.state.usedCts = [];
    this.state.unusedCts = [{ text: 'None', value: 0 }];
    Object.values(this.state.data.loads).forEach((load) => {
      if (load !== item) {
        for (let i = 0; i < 3; i += 1) {
          if (load.cts[i].channel !== 0) {
            this.state.usedCts.push(load.cts[i].channel);
            this.state.data.allCts[load.cts[i].channel - 6].active = true;
          }
        }
      }
    });
    for (let x = 6; x < this.state.data.deviceInfo.model + 6; x += 1) {
      if (this.state.usedCts.indexOf(x) === -1) {
        this.state.unusedCts.push({ text: `CT ${x - 5}`, value: x });
        this.state.data.allCts[x - 6].active = false;
      }
    }
    return this.state.unusedCts;
  },
  updateInputs() {
    Object.values(this.state.data.inputs).forEach((input) => {
      // eslint-disable-next-line
      input.used = false;
      for (let i = 0; i < 3; i += 1) {
        if (!input.lines[i].active) {
          // eslint-disable-next-line
          input.lines[i].channel = -1;
        }
      }
      if (input.voltageScaler === undefined) {
        input.voltageScaler = 1;
      }
    });
    Object.values(this.state.data.loads).forEach((load) => {
      this.state.data.inputs[load.input].used = true;
    });
    if (this.state.data.deviceInfo.model === 3) {
      this.state.data.inputs.splice(1, 1);
    }
  },
  generateCts() {
    this.state.data.deviceInfo.model = 48;
    this.state.data.deviceInfo.loaded = 0;
    this.state.data.allCts = Array(this.state.data.deviceInfo.model);
    Object.values(this.state.data.loads).forEach((load) => {
      for (let i = 0; i < 3; i += 1) {
        if (load.cts[i].active) {
          this.state.data.allCts[load.cts[i].channel - 6] = load.cts[i];
          this.state.data.allCts[load.cts[i].channel - 6].unsaved = true;
        }
      }
    });
    for (let x = 6; x < this.state.data.deviceInfo.model + 6; x += 1) {
      if (this.state.data.allCts[x - 6] === undefined) {
        const ct = {
          channel: x,
          active: false,
          type: 0,
          inverse: false,
          unsaved: false,
        };
        Vue.set(this.state.data.allCts, x - 6, ct);
      }
    }
    this.updateCts();
  },
  refreshData() {
    this.updateLogin();
    this.getStaticDeviceInfo();
    this.getDeviceInfo();
    this.getBaseTime();
    this.updateTimezones();
    this.getEthernet();
    this.getCommunication();
    this.getPulse();
    this.getAlarms();
    this.getReport();
    this.getLog();
    this.updateAlarmStates();
    this.updateAlarmLog();
    this.updateAlarmLed();
    this.updateAlarmRelay();
    this.updateJournal();
    this.updateMapping();

    this.state.timeUpdated = false;
  },
  updateTimezones() {
    this.state.timezones = [];
    ajax.get('system/timezones')
      .then((response) => {
        this.state.timezones = response.data.all;
        this.timezoneUpdated();
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  timezoneUpdated() {
    this.state.timezoneIndex = -1;
    for (let i = 0; i < this.state.timezones.length; i++) {
      if (this.state.timezones[i].name === this.state.timezone) {
        this.state.timezoneIndex = i;
        break;
      }
    }
  },
  updateMapping() {
    ajax.get('config/mapping')
      .then((response) => {
        this.state.mappingSaved = true;
        this.json = response.data;
        this.state.data.loads.splice(0, this.state.data.loads.length);
        this.state.data.inputs.splice(0, this.state.data.inputs.length);
        this.state.data.allCts.splice(0, this.state.data.allCts.length);
        if (this.json.inputs) {
          this.state.data.inputs = this.json.inputs;
        }
        // if (this.json.loads) {
        //   Object.values(this.json.loads).forEach((load) => {
        //     for (let i = 0; i < 3; i += 1) {
        //       if (load.cts[i].vdi === undefined || load.cts[i].vdi === null) {
        //         load.cts[i].vdi = 4194303; // eslint-disable-line no-param-reassign
        //       }
        //     }
        //     if (load.active) {
        //       const loadCopy = {};
        //       Object.assign(loadCopy, load);
        //       for (let i = 0; i < 3; i += 1) {
        //         if (loadCopy.cts[i].channel !== 0) {
        //           loadCopy.cts[i].unsaved = true;
        //         }
        //       }
        //       this.state.data.loads.push(loadCopy);
        //     }
        //   });
        // }
        if (this.json.loads.length > 0) {
          for (let li = 0; li < this.json.loads.length; li += 1) {
            if (this.json.loads[li].active) {
              for (let i = 0; i < 3; i += 1) {
                if (this.json.loads[li].cts[i].vdi === undefined || this.json.loads[li].cts[i].vdi === null) {
                  this.json.loads[li].cts[i].vdi = 4194303; // eslint-disable-line no-param-reassign
                }
              }
              const loadCopy = {};
              Object.assign(loadCopy, this.json.loads[li]);
              for (let i = 0; i < 3; i += 1) {
                if (loadCopy.cts[i].channel !== 0) {
                  loadCopy.cts[i].unsaved = true;
                }
              }
              this.state.data.loads.push(loadCopy);
            }
          }
        }
        this.updateInputs();
        this.generateCts();
        Object.values(this.state.data.allCts).forEach((ct) => {
          if (ct.vdi === 4194303) {
            delete ct.vdi; // eslint-disable-line no-param-reassign
          }
        });
        Object.values(this.state.data.loads).forEach((load) => {
          if (load.vdi === 4194303) {
            delete load.vdi; // eslint-disable-line no-param-reassign
          }
        });

        this.updateVdis();
        this.state.voltageDirty = false;
        this.state.loadDirty = false;
        this.state.ctDirty = false;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
        this.json = [];
      });
  },
  saveMapping() {
    Object.values(this.state.data.allCts).forEach((ct) => {
      if (ct.vdi === undefined || ct.vdi === null || ct.vdi === '') {
        ct.vdi = 4194303; // eslint-disable-line no-param-reassign
      }
    });
    Object.values(this.state.data.loads).forEach((load) => {
      if (load.vdi === undefined || load.vdi === null || load.vdi === '') {
        load.vdi = 4194303; // eslint-disable-line no-param-reassign
      }
      for (let i = 0; i < 3; i += 1) {
        if (load.active) {
          if (load.cts[i].active) {
            /* eslint-disable */
            load.cts[i] = this.state.data.allCts[load.cts[i].channel - 6];
            load.cts[i].maxRating = Number(load.cts[i].maxRating);
            load.cts[i].maxOutput = Number(load.cts[i].maxOutput);
            load.cts[i].phaseCorrection = Number(load.cts[i].phaseCorrection);
            /* eslint-enable */
          }
        }
      }
    });

    Object.values(this.state.data.inputs).forEach((input) => {
      if (input.voltage === '') {
        // eslint-disable-next-line
        input.voltage = 0;
      } else {
        // eslint-disable-next-line
        input.voltage = parseFloat(input.voltage);
      }
      input.active = false;
      for (let i = 0; i < 3; i += 1) {
        if (input.lines[i].channel === -1) {
          // eslint-disable-next-line
          input.lines[i].active = false;
          // eslint-disable-next-line
          input.lines[i].channel = 0;
        } else if (input.lines[i].active) {
          // eslint-disable-next-line
          // input.lines[i].active = true;
          input.active = true;
        }
      }
    });

    this.json.loads = JSON.parse(JSON.stringify(this.state.data.loads));

    for (let i = this.state.data.loads.length; i < 48; i += 1) {
      this.json.loads.push({ id: i, active: false });
    }

    Object.values(this.state.data.allCts).forEach((ct) => {
      if (ct.vdi === 4194303) {
        delete ct.vdi; // eslint-disable-line no-param-reassign
      }
    });
    Object.values(this.state.data.loads).forEach((load) => {
      if (load.vdi === 4194303) {
        delete load.vdi; // eslint-disable-line no-param-reassign
      }
    });


    this.json.inputs = this.state.data.inputs;

    return new Promise((resolve, reject) => {
      ajax.put('config/mapping', this.json)
        .then(() => {
          this.state.mappingSaved = true;
          this.state.voltageDirty = false;
          this.state.loadDirty = false;
          this.state.ctDirty = false;
          this.updateMapping(); // Request mapping after saving so inomplete mappings by partial imports are detected.
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.mappingSaved = false;
          reject(e);
        });
    });
  },
  getStaticDeviceInfo() {
    if (!this.state.data.deviceInfo.loaded) {
      ajax.get('config/static')
        .then((response) => {
          this.state.data.deviceInfo = response.data;
          this.state.data.deviceInfo.loaded = true;
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
        });
    }
  },
  getDeviceInfo() {
    ajax.get('config/info')
      .then((response) => {
        this.state.data.general = response.data;
        if (this.state.data.general.defaults.billingCycleDay === undefined) {
          this.state.data.general.defaults.billingCycleDay = 1;
        }
        if (this.state.data.general.defaults.billingCycleTime === undefined) {
          this.state.data.general.defaults.billingCycleTime = 0;
        }
        this.state.generalDirty = false;
        this.state.generalSaved = true;
        this.state.generalValid = true;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getEthernet() {
    ajax.get('config/ethernet')
      .then((response) => {
        this.state.data.ethernet = response.data;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getCommunication() {
    ajax.get('config/communication')
      .then((response) => {
        this.state.data.communications = response.data;
        this.state.communicationsDirty = false;
        this.state.communicationsSaved = true;
        this.state.communicationsValid = true;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getPulse() {
    ajax.get('config/pulse')
      .then((response) => {
        this.state.data.pulse = response.data;

        Object.values(this.state.data.pulse).forEach((pulse) => {
          if (pulse.loadId === undefined) {
            pulse.loadId = -1;
          }
        });

        this.state.selectedPulse = JSON.parse(JSON.stringify(this.state.data.pulse[0]));
        this.state.pulseDirty = false;
        this.state.pulseSaved = true;
        this.state.pulseValid = true;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getAlarms() {
    ajax.get('config/alarms')
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].type !== -1 && this.state.alarmTypes.find(t => t.value === response.data[i].type).floatAsInteger === true) {
            response.data[i].setPoint /= 100;
            response.data[i].deadband /= 100;
          }
        }
        this.state.data.alarms = response.data;
        this.state.alarmsDirty = false;
        this.state.overlappingAlarmsDirty = false;
        this.state.alarmsSaved = true;
        this.state.alarmsValid = true;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getReport() {
    ajax.get('config/report')
      .then((response) => {
        this.state.data.report = response.data;
        this.state.reportDirty = false;
        this.state.reportSaved = true;
        this.state.reportValid = true;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getLog() {
    ajax.get('config/log')
      .then((response) => {
        this.state.eventLog = [];
        const log = response.data.eventLog;
        log.forEach((logLine) => {
          this.state.eventLog.push({ time: new Date(logLine.time), text: logLine.text });
        });
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateAlarmStates() {
    ajax.get('config/alarms')
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) { // .find(t => t.value === dataToSave[i].type)
          if (response.data[i].type !== -1 && this.state.alarmTypes.find(t => t.value === response.data[i].type).floatAsInteger === true) {
            response.data[i].setPoint /= 100;
            response.data[i].deadband /= 100;
          }
        }
        this.state.alarmStates = response.data;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateAlarmLog() {
    ajax.get('config/alarmlog')
      .then((response) => {
        this.state.alarmLog = response.data.alarmLog;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateAlarmLed() {
    ajax.get('config/alarm/led')
      .then((response) => {
        this.state.alarmLed = response.data.state;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateAlarmRelay() {
    ajax.get('config/alarm/relay')
      .then((response) => {
        this.state.alarmRelay = response.data.state;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  updateJournal() {
    this.state.journalEntries = [];
    ajax.post('system/journal', { hours: 24, format: 'json' })
      .then((response) => {
        this.state.journalEntries = response.data.journalEntries;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
      });
  },
  getBaseTime() {
    ajax.get('system/time')
      .then((response) => {
        this.state.basetime = response.data.time * 1000;
        if (response.data.timezone === undefined || response.data.timezone === null || response.data.timezone === '') {
          this.state.timezone = 'America/New_York';
        } else {
          this.state.timezone = response.data.timezone;
        }
        this.timezoneUpdated();
        if (this.state.timeInterval === null) {
          this.state.timeInterval = setInterval(this.updateTime.bind(this), 1000);
        }
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
        this.state.basetime = 0;
      });
  },
  updateTime() {
    this.state.basetime += 1000;
    const d = new Date();
    d.setTime(this.state.basetime);
    this.state.now = d;
  },
  updateLogin() {
    ajax.get('login')
      .then((response) => {
        this.state.data.pinEnabled = response.data.enabled;
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
        this.state.data.pinEnabled = true;
      });
  },
  saveInfo() {
    return new Promise((resolve, reject) => {
      ajax.put('config/info', this.state.data.general)
        .then(() => {
          this.state.generalDirty = false;
          this.state.generalSaved = true;
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.generalSaved = false;
          reject(e);
        });
    });
  },
  saveEthernet() {
    return new Promise((resolve, reject) => {
      const netmask = this.state.data.ethernet.subnetMask;
      // eslint-disable-next-line
      this.state.data.ethernet.cidr = netmask.split('.').map(Number).map(part => (part >>> 0).toString(2)).join('')
        .split('1').length - 1;
      ajax.put('config/ethernet', this.state.data.ethernet)
        .then(() => {
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          reject(e);
        });
    });
  },
  savePulse() {
    return new Promise((resolve, reject) => {
      Object.values(this.state.data.pulse).forEach((io) => {
        /* eslint-disable */
        io.scaler = Number(io.scaler);
        io.pulseWidth = Number(io.pulseWidth);
        /* eslint-enable */
      });
      ajax.put('config/pulse', this.state.data.pulse)
        .then(() => {
          this.state.pulseDirty = false;
          this.state.pulseSaved = true;
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.pulseSaved = false;
          reject(e);
        });
    });
  },
  saveCommunication() {
    return new Promise((resolve, reject) => {
      ajax.put('config/communication', this.state.data.communications)
        .then(() => {
          this.state.communicationsDirty = false;
          this.state.communicationsSaved = true;
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.communicationsSaved = false;
          reject(e);
        });
    });
  },
  saveAlarms() {
    return new Promise((resolve, reject) => {
      const dataToSave = JSON.parse(JSON.stringify(this.state.data.alarms));
      for (let i = 0; i < dataToSave.length; i++) {
        if (dataToSave[i].type !== -1 && this.state.alarmTypes.find(t => t.value === dataToSave[i].type).floatAsInteger === true) {
          dataToSave[i].setPoint = parseInt(dataToSave[i].setPoint * 100, 10);
          dataToSave[i].deadband = parseInt(dataToSave[i].deadband * 100, 10);
        }
      }
      ajax.put('config/alarms', dataToSave)
        .then(() => {
          this.state.alarmsDirty = false;
          this.state.overlappingAlarmsDirty = false;
          this.state.alarmsSaved = true;
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.alarmsSaved = false;
          reject(e);
        });
    });
  },
  saveReport() {
    return new Promise((resolve, reject) => {
      ajax.put('config/report', this.state.data.report)
        .then(() => {
          this.state.reportDirty = false;
          this.state.reportSaved = true;
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.state.reportSaved = false;
          reject(e);
        });
    });
  },
  saveTime() {
    return new Promise((resolve, reject) => {
      const json = { time: this.state.basetime, timezone: this.state.timezone };
      ajax.put('system/time', json)
        .then(() => {
          this.getBaseTime();
          this.updateTimezones(); // Because of daylight-savings the offset to UTC might have changed
          resolve();
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          reject(e);
        });
    });
  },

  getAlarmTextForAlarmLogs(item) {
    let returnValue = `Alarm #${item.id + 1} `;
    returnValue += this.state.alarmTypes[item.type].text;
    if (this.state.alarmTypes[item.type].vinApplicable) {
      if (returnValue.endsWith(' (Vin)')) {
        returnValue = returnValue.substr(0, returnValue.length - 6);
      }
      returnValue += ` - Vin #${item.vinLineLoadOrCt + 1}`;
    } else if (this.state.alarmTypes[item.type].loadApplicable) {
      if (returnValue.endsWith(' (Load)')) {
        returnValue = returnValue.substr(0, returnValue.length - 7);
      }
      returnValue += ` - Load #${item.vinLineLoadOrCt + 1}`;
    } else if (this.state.alarmTypes[item.type].ctApplicable) {
      if (returnValue.endsWith(' CT')) {
        returnValue = returnValue.substr(0, returnValue.length - 3);
      }
      returnValue += ` - CT #${item.vinLineLoadOrCt + 1}`;
    } else if (this.state.alarmTypes[item.type].lineApplicable) {
      if (returnValue.endsWith(' Voltage')) {
        if (item.vinLineLoadOrCt > 2) {
          returnValue += ` - Vin #2 - Line #${item.vinLineLoadOrCt - 2}`;
        } else {
          returnValue += ` - Vin #1 - Line #${item.vinLineLoadOrCt + 1}`;
        }
      }
    }

    if (item.setPoint !== -1 && this.state.alarmTypes[item.type].setPointApplicable) {
      returnValue += ` @ ${item.setPoint}${this.state.alarmTypes[item.type].unit}`;
    }
    if (this.state.alarmTypes[item.type].deadbandUnit !== '' && item.deadband !== 0) {
      returnValue += ` with deadband of ${item.deadband}${this.state.alarmTypes[item.type].deadbandUnit}`;
    }
    if (this.state.alarmTypes[item.type].delayApplicable && item.delay !== 0) {
      returnValue += ` with delay of ${item.delay} seconds`;
    }
    returnValue += '.';
    if (item.led) {
      if (item.relay) {
        returnValue += ' Turn Led on and trigger relay when state is Alarm.';
      } else {
        returnValue += ' Turn Led on when state is Alarm.';
      }
    } else if (item.relay) {
      returnValue += ' Trigger relay when state is Alarm.';
    }
    return returnValue;
  },

  getStateTextForAlarmLogs(state) {
    switch (state) {
      case 0:
        return ''; // Startup
      case 1:
        return 'Normal';
      case 2:
        return 'Normal';
      case 3:
        return 'Warning (Under)';
      case 4:
        return 'Warning (Over)';
      case 5:
        return 'Alarm (Under)';
      case 6:
        return 'Alarm (Over)';
      case 7:
        return 'Acknowledged';
      default:
        return '#NA';
    }
  },
  getDeviceModelNumberText() {
    if (this.state.data.deviceInfo.model <= 9) {
      return `0${this.state.data.deviceInfo.model}`;
    }
    return `${this.state.data.deviceInfo.model}`;
  },
};
